import { action, computed, observable } from 'mobx';

class ModalStore {
    private _onClose?: () => void;

    @observable private _currentModal: ModalType = ModalType.NONE;

    @computed
    public get currentModal(): ModalType {
        return this._currentModal;
    }

    @action
    public setModal(type: ModalType, onClose?: () => void): void {
        this._onClose = undefined;
        if (onClose) {
            this._onClose = onClose;
        }
        this._currentModal = type;
    }

    @action
    public closeModal(): void {
        this._currentModal = ModalType.NONE;
        if (typeof this._onClose === 'function') {
            this._onClose();
        }
    }
}

enum ModalType {
    NONE = 'NONE',
    SIGNUP = 'SIGNUP',
    LOGIN = 'LOGIN',
    ADD_FAMILY_MEMBERS = 'ADD_FAMILY_MEMBERS',
    ADD_TAG_TO_ARTIFACT = 'ADD_TAG_TO_ARTIFACT',
    ARTIFACT_UPLOADER = 'ARTIFACT_UPLOADER',
    NEW_FAMILY = 'NEW_FAMILY',
    EDIT_COLLECTION = 'EDIT_COLLECTION',
    EDIT_ARTIFACT = 'EDIT_ARTIFACT',
    USER_PREFERENCES = 'USER_PREFERENCES',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD',
    RESET_PASSWORD = 'RESET_PASSWORD'
}

export { ModalStore, ModalType };



// WEBPACK FOOTER //
// ./src/_stores/ModalStore.ts